import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_AT_LEAST_ONE_IMAGE,
  STR_AVAILABLE_QUANTITY,
  STR_CATEGORY,
  STR_COULD_NOT_FETCH_DATA,
  STR_CROPS,
  STR_DELIVERY_LOCATION,
  STR_IMAGES,
  STR_INVALID_LOCATION,
  STR_INVALID_QUANTITY,
  STR_INVALID_TITLE,
  STR_INVALID_UNIT_PRICE,
  STR_ITEM_DESCRIPTION,
  STR_ITEM_LOCATION,
  STR_ITEM_TITLE,
  STR_LIVESTOCK,
  STR_MOQ,
  STR_OPTIONAL,
  STR_ORDER_NOTES,
  STR_ORDER_QUANTITY,
  STR_OVERALL_COST,
  STR_PACKAGING_COST,
  STR_PLACE_ORDER,
  STR_PLACE_YOUR_ORDER,
  STR_POST_ITEM,
  STR_SHIPPING_COST,
  STR_SUBMIT,
  STR_SUCCESS,
  STR_TOTAL_ORDER_PRICE,
  STR_TRANSACTION_FEES,
  STR_UNIT,
  STR_UNIT_PRICE
} from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import ImageSlider from "../ones/ImagesSlider";
import OpSuccessWidget from "../ones/OpSuccessWidget";

export default function ViewItem({ uuid }) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const [opSuccessful, setOpSuccessful] = useState(false);

  const [data, setData] = useState(null);
  const [images, setImages] = useState([]);

  const [itemQuantity, setItemQuantity] = useState(1);
  const [deliveryLocation, setDeliveryLocation] = useState({});
  const [notes, setNotes] = useState("");

  const [totalOrderPrice, setTotalOrderPrice] = useState(0);
  const [transactionFees, setTransactionFees] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [packagingCost, setPackagingCost] = useState(0);
  const [overallCost, setOverallCost] = useState(0);

  async function init() {
    setReady(false);
    await getData();
    setReady(true);
  }

  async function getData() {
    await callApi("get-item-data", { itemUuid: uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
      }
    })
  }

  function getImages() {
    if (!data) return;
    const imgs = [];
    if (data.img1) imgs.push(CDN_URL + data.img1);
    if (data.img2) imgs.push(CDN_URL + data.img2);
    if (data.img3) imgs.push(CDN_URL + data.img3);
    setImages(imgs);
  }

  function calcTotals() {
    setTotalOrderPrice(Number(itemQuantity) * Number(data.unitPrice || 0));
  }

  function calcOverall() {
    setOverallCost(
      Number(totalOrderPrice) +
      Number(transactionFees) +
      Number(packagingCost) +
      Number(shippingCost)
    );
  }

  async function placeOrder() {
    if (Number(itemQuantity) <= 0 || isNaN(itemQuantity)) {
      return appContext.tellError(STR_INVALID_QUANTITY[appContext.language]);
    }

    if (!deliveryLocation?.region) {
      return appContext.tellError(STR_INVALID_LOCATION[appContext.language]);
    }

    setLoading(true);
    await callApi("create-order", {
      itemUuid: uuid,
      itemQuantity,
      deliveryLocation: JSON.stringify(deliveryLocation),
      notes,
    }).then(res => {
      if (res.status === 1) {
        setOpSuccessful(true);
        appContext.getMyOrders();
      } else {
        appContext.tellError(res.msg);
      }
    });
    setLoading(false);
  }

  useEffect(() => { init(); }, []);
  useEffect(() => { if (data) getImages(); }, [data]);
  useEffect(() => { if (data) calcTotals(); }, [itemQuantity]);
  useEffect(() => { calcOverall(); }, [totalOrderPrice, transactionFees, packagingCost, shippingCost]);
  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
    return () => appContext.setShowOverlayLoader(false);
  }, [loading]);

  if (!ready || !data) {
    return <div style={{ padding: 40 }}>{getInlineLoader()}</div>;
  }

  return (
    <div className="container" style={{ paddingBottom: "100px" }}>
      <div className="row">

        {/* Title */}
        <div className="col-12 mb-3">
          <h4 style={{ fontWeight: 700 }}>{data.title}</h4>
        </div>

        {/* Images */}
        <div className="col-md-6 mb-3">
          <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "var(--shadow3)" }}>
            <ImageSlider images={images} />
          </div>
        </div>

        {/* Item Info */}
        <div className="col-md-6 mb-3">
          <div style={{
            background: "var(--surfaceColor)",
            borderRadius: 18,
            padding: 16,
            boxShadow: "var(--shadow3)"
          }}>

            <div style={{ marginBottom: 10 }}>
              <span
                style={{
                  padding: "6px 12px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                  background: data.category === "crop"
                    ? "var(--primaryColor)"
                    : "var(--secondaryColor)",
                  color: "#fff"
                }}
              >
                Bidhaa
              </span>
            </div>

            <div style={{ fontSize: 30, fontWeight: 700, color: "var(--primaryColor)" }}>
              {formatMoney(data.unitPrice)} TZS
            </div>

            <div style={{ opacity: 0.7, textTransform: "uppercase", marginBottom: 12 }}>
              {data.unit}
            </div>

            <label style={{ fontWeight: 600 }}>{STR_ITEM_DESCRIPTION[appContext.language]}</label>
            <pre style={{
              background: "rgba(0,0,0,0.03)",
              padding: 12,
              borderRadius: 12,
              whiteSpace: "pre-wrap"
            }}>
              {data.description}
            </pre>
          </div>
        </div>

        {/* Order Section */}
        <div className="col-12 mt-4">
          {opSuccessful ? <OpSuccessWidget /> : (
            <>
              <h5 style={{ fontWeight: 700, marginBottom: 16 }}>
                {STR_PLACE_YOUR_ORDER[appContext.language]}
              </h5>

              <div className="row">

                {/* Left */}
                <div className="col-md-6">

                  <div style={{ marginBottom: 16 }}>
                    <label>{STR_ORDER_QUANTITY[appContext.language]}</label>
                    <input
                      value={itemQuantity}
                      onChange={e => setItemQuantity(e.target.value)}
                      className="form-control text-end"
                      style={{ fontSize: 22, fontWeight: 700 }}
                    />
                  </div>

                  {[
                    [STR_TOTAL_ORDER_PRICE, totalOrderPrice],
                    [STR_TRANSACTION_FEES, transactionFees],
                    [STR_PACKAGING_COST, packagingCost],
                    [STR_SHIPPING_COST, shippingCost],
                    [STR_OVERALL_COST, overallCost, true],
                  ].map(([label, value, highlight], i) => (
                    <div key={i} style={{
                      background: "var(--surfaceColor)",
                      padding: 12,
                      borderRadius: 14,
                      marginBottom: 8,
                      fontWeight: highlight ? 700 : 500,
                      fontSize: highlight ? 20 : 16
                    }}>
                      {label[appContext.language]}
                      <div style={{ float: "right" }}>
                        {formatMoney(value)} TZS
                      </div>
                    </div>
                  ))}
                </div>

                {/* Right */}
                <div className="col-md-6">
                  <label>{STR_DELIVERY_LOCATION[appContext.language]}</label>
                  <NapaAddressPicker callback={setDeliveryLocation} />

                  <div className="mt-3">
                    <label>{STR_ORDER_NOTES[appContext.language]}</label>
                    <textarea
                      className="form-control"
                      value={notes}
                      onChange={e => setNotes(e.target.value)}
                    />
                    <small>{STR_OPTIONAL[appContext.language]}</small>
                  </div>
                </div>

                <div className="col-12 mt-4">
                  <button
                    className="btn btn-primary btn-rounded btn-block"
                    style={{ padding: "14px", fontWeight: 700 }}
                    onClick={placeOrder}
                  >
                    {STR_SUBMIT[appContext.language]}
                  </button>
                </div>

              </div>
            </>
          )}
        </div>

      </div>
    </div>
  )
}
